import React, { useEffect, useState  } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';
import loginBgImage from '../../assets/images/bg1.jpg';
import logoIcon from '../../assets/images/logo-icon.png';
import envelopeIcon from '../../assets/images/envelope.png';
import passwordIcon from '../../assets/images/password.png';
import Loader from '../../components/Loader/Loader';
import { Validation } from '../../utils/validation';
import UserServices from '../../services/UserServices';
import useAuth from '../../hooks/useAuth';

const LoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const userServices = new UserServices();

  useEffect(() => {
      seo({
          title: SITE_TITLE + ' || Login',
          metaDescription: '',
      });
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newError = {
      ...errors,
      'api_error': '',
      [name]:''
    };
    setErrors(newError);
    const newFormData = {
        ...formData,
        [name]: value,
    };
    setFormData(newFormData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = Validation(formData,['username','password']);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    submitForm();
  };

  const submitForm = async () => {
    setIsLoading(true);
    try {
      userServices.login(formData).then(response => {
        setIsLoading(false);
        if(response.data.status === 'success') {
          login(response.data.result); // Save globally
          navigate('/net-price-report');      // redirect after login
        } else {
          const newError = {
            ...errors,
            'api_error': response.data.message,
          };
          setErrors(newError);
        }
      }).catch(error => {
        // Network or server error
        const errorMsg = error.message || 'Something went wrong. Please try again later.';
        setErrors(prev => ({
          ...prev,
          api_error: errorMsg,
        }));
      });
    } catch (error) {
      console.log(error.message);
      const newError = {
        ...errors,
        'api_error': error.message,
      };
      setErrors(newError);
    }
  };

  const renderLoginForm = () => {
    return(
      <React.Fragment>
        <form className="warehouse-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-12">
              <div className="input-group mb-2">
                <span className="input-group-text"><img src={envelopeIcon} alt="" className="d-block img-fluid" /></span>
                <input type="text" className="form-control" placeholder="Username" value={formData.username || ''} id="username" name="username" onChange={handleChange}/>
                {errors.username && <div className="text-danger">{errors.username}</div>}
              </div>
            </div>
            <div className="col-md-12"> 
              <div className="input-group mb-2 password-img">
                <span className="input-group-text"><img src={passwordIcon} alt="" className="d-block img-fluid" /></span>
                <input type="password" className="form-control" id="password" placeholder="Password" name="password" onChange={handleChange}/>
                {errors.password && <div className="text-danger">{errors.password}</div>}
              </div>
            </div>
            
            {errors.api_error && <div className="col-12 text-danger text-center">{errors.api_error}</div>}
            <div className="col-12">
              <button type="submit" className="btn login-btn">Login</button>
            </div>  
          </div>
        </form>
      </React.Fragment>
    )
  }
  
  return (
    <React.Fragment>
      <section className="techtop-qc-login-page" style={{ backgroundImage: `url(${loginBgImage})` }} >
        <div className="container">
          <div className="row">
            <div className="col-12 centerDiv">
              <div className="techtop-login-div">
                <div className="logo-icon">
                  <img src={logoIcon} alt="" className="d-block mx-auto img-fluid" />
                </div>  
                <h5>Techtop Internal Portal</h5>
                {renderLoginForm()}
              </div>  
            </div>
          </div>
        </div>
        <Loader isLoading={isLoading} message="Processing..."/>
      </section>
    </React.Fragment>
  );
}

export default LoginPage;